module.exports = __webpack_public_path__ + "videos/whats-new_cn.91ce7fb.mp4";